import { createApp, ref } from "vue";
import App from "./App.vue";

import "./assets/index.css";
import router from "./router";
import store from "./store";
import helper from "@/utils/helper";
import "./registerServiceWorker";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import "../src/assets/style.css";
import VueApexCharts from "vue3-apexcharts";

const app = createApp(App);
// We use this in axios interceptor to set loading status
app.config.globalProperties.$loading = ref(false);

app
  .use(store)
  .use(router)
  .use(helper)
  .use(VueApexCharts)
  .use(Vue3PersianDatetimePicker, {
    name: "CustomDatePicker",
    props: {
      format: "YYYY-MM-DD",
      displayFormat: "jYYYY-jMM-jDD",
      editable: false,
      inputClass: "form-control my-custom-class-name",
      placeholder: "لطفا یک تاریخ انتخاب کنید",
      altFormat: "YYYY-MM-DD",
      color: "#8f6008",
      autoSubmit: false,
    },
  })
  .mount("#app");
  window.Apex.chart = { fontFamily: "iransans" };

export default app;
